<nz-card class="custom-card with-avatar">
  <div *ngIf="user; else loading">
    <div class="custom-card_avatar">
      <img [src]="getSanitizeUrl(user.img_path)" alt="" />
    </div>

    <div class="custom-card_title">
      <h2>{{ user.name }}</h2>
      <small>{{ user.role }}</small>
    </div>

    <div class="custom-card_body">
      <div class="mb-1">Ultima review</div>
      <p class="m-0" *ngIf="!lastReview">Nessuna review precendente</p>
      <time [attr.datetime]="lastReview">{{ lastReview }}</time>

      <p>Progetti in corso</p>

      <div>
        <div
          class="list-projects"
          *ngIf="activeProjects && activeProjects.length > 0; else noProjects">
          <img
            *ngFor="let project of activeProjects"
            class="project-img"
            [src]="getSanitizeUrl(project.img_path)"
            alt=""
            nz-tooltip
            nzTooltipTitle="{{ project.alias }}"
            nzTooltipPlacement="top" />
        </div>

        <ng-template #noProjects>
          <p>Nessun progetto in corso</p>
        </ng-template>
      </div>
    </div>

    <div class="custom-card_footer">
      <div>Progetti in cui hai lavorato</div>
      <div
        class="list-projects"
        *ngIf="pastProjects && pastProjects.length > 0; else noPastProjects">
        <img
          class="project-img"
          *ngFor="let project of pastProjects"
          [src]="getSanitizeUrl(project.img_path)"
          alt=""
          nz-tooltip
          nzTooltipTitle="{{ project.alias }}"
          nzTooltipPlacement="top" />
      </div>

      <ng-template #noPastProjects>
        <p>Nessuno storico trovato</p>
      </ng-template>
    </div>
  </div>
  <ng-template #loading>
    <nz-skeleton-element
      class="custom-card_avatar"
      nzType="avatar"
      [nzActive]="true"
      [nzShape]="'circle'"
      [nzSize]="'large'"></nz-skeleton-element>
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 6 }"></nz-skeleton>
  </ng-template>
</nz-card>
